<script setup lang="ts">
import { onBeforeUnmount, onMounted, watch } from 'vue'
import { RouterView } from 'vue-router'
import { Toaster } from '@/components/ui/sonner'
import OfflineBanner from '@/components/common/OfflineBanner.vue'
import { replayPendingMutations } from '@/lib/offline-db'
import { startRealtime, stopRealtime } from '@/lib/realtime'
import { useAuthStore } from '@/stores/auth.store'

const auth = useAuthStore()

// The live socket follows the session: it opens for a signed-in agent, courier or customer, and is
// closed the moment they sign out or become someone else.
watch(
  () => [auth.token, auth.user?.id, auth.user?.role] as const,
  ([token]) => void startRealtime(token ? auth.user : null),
  { immediate: true }
)

function replayWhenOnline() {
  if (navigator.onLine) {
    void replayPendingMutations()
  }
}

onMounted(() => {
  replayWhenOnline()
  window.addEventListener('online', replayWhenOnline)
})

onBeforeUnmount(() => {
  window.removeEventListener('online', replayWhenOnline)
  stopRealtime()
})
</script>

<template>
  <OfflineBanner />
  <RouterView />
  <Toaster />
</template>
